import React, { useState } from 'react';
import { Tooltip, Typography } from 'antd';

interface ExpandableTextCellProps {
	text: string;
	maxRows?: number;
}

const ExpandableTextCell: React.FC<ExpandableTextCellProps> = ({
	text,
	maxRows = 3,
}) => {
	const [expanded, setExpanded] = useState(false);

	if (!text) {
		return null;
	}

	return (
		<Tooltip title={text}>
			<Typography.Paragraph
				ellipsis={{
					rows: maxRows,
					expandable: 'collapsible',
					expanded: expanded,
					symbol: (currentExpanded) => (currentExpanded ? ' less' : ' more'),
					onExpand: (_e, info) => setExpanded(info.expanded),
				}}
				style={{ margin: 0 }}
			>
				{text}
			</Typography.Paragraph>
		</Tooltip>
	);
};

export default ExpandableTextCell;
